import React from 'react';
import ResTable from "./ResTable";


const PageRace = () => (
    <div className="page-race">
        <ResTable />
    </div>
);

export default PageRace;
